<template>
    <v-container class="fill-height pa-4" fluid>
        <v-row justify="center" align="center">
            <v-col cols="12" sm="9" md="6" lg="4" xl="3">
                <v-card class="pa-6" rounded="lg" elevation="3">
                    <div class="text-overline grey--text mb-3">DG Ventures</div>

                    <div v-if="state === 'loading'" class="text-center py-10">
                        <v-progress-circular indeterminate color="primary" size="36" />
                        <p class="text-body-2 grey--text text--darken-1 mt-4 mb-0">Logging you in…</p>
                    </div>

                    <template v-else-if="state === 'error'">
                        <div class="text-h4 mb-2">⚠️</div>
                        <div class="text-h6 font-weight-bold mb-1">Couldn't log you in</div>
                        <p class="text-body-2 grey--text text--darken-1 mb-5">{{ errorMessage }}</p>
                        <v-btn href="/" color="grey lighten-3" depressed block class="text-none">
                            Go to login
                        </v-btn>
                    </template>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'AccountAutologinComponent',
    data() {
        return {
            state: 'loading', // loading | error
            errorMessage: '',
        };
    },
    computed: {
        id() {
            return this.$route.params.id;
        },
        query() {
            return window.location.search;
        },
        endpoint() {
            return `/api/account-requests/autologin/${this.id}`;
        },
    },
    async mounted() {
        try {
            const { data } = await this.$axios.get(this.endpoint + this.query);
            if (data && data.response) {
                this.$store.dispatch('auth/set_user', data.user);
                this.$store.dispatch('auth/set_token', data.token);
                this.$store.dispatch('settings/setBaselineTimezone', data.baseline_timezone);
                this.$store.dispatch('settings/adoptUserPreferences', data.user);
                this.$store.dispatch('auth/set_roles', data.roles);
                this.$store.dispatch('tasks/set_priorities', data.priorities);
                this.$store.dispatch('tasks/set_statuses', data.statuses);
                this.$store.dispatch('meetings/set_meeting_statuses', data.meeting_statuses);
                this.$store.dispatch('projects/set_project_statuses', data.project_statuses);
                this.$toast.success('Welcome to DG Tasks!');
                const destRoute = this.$route.params.dest === 'floor-plan' ? 'FloorPlan' : 'Dashboard';
                this.$router.push({ name: destRoute });
            } else {
                this.errorMessage = (data && data.message) || 'This login link is invalid.';
                this.state = 'error';
            }
        } catch (e) {
            const message = e.response && e.response.data && e.response.data.message;
            this.errorMessage = message || 'This login link has already been used or has expired.';
            this.state = 'error';
        }
    },
};
</script>
